document.addEventListener('DOMContentLoaded', function () {
	function closeModal(modal) {
		if (modal) {
			modal.classList.remove('is-open');
		}
	}

	document.querySelectorAll('.kt-modal-close').forEach(function (btn) {
		['click', 'touchend'].forEach(function (eventType) {
			btn.addEventListener(eventType, function (e) {
				e.preventDefault();
				closeModal(btn.closest('.kadence-block-pro-modal'));
			});
		});
	});

	document.querySelectorAll('.kt-modal-overlay').forEach(function (overlay) {
		['click', 'touchend'].forEach(function (eventType) {
			overlay.addEventListener(eventType, function (e) {
				if (!e.target.closest('.kt-modal-container')) {
					e.preventDefault();
					closeModal(overlay.closest('.kadence-block-pro-modal'));
				}
			});
		});
	});
});
